import React, { useEffect } from "react";
import { Grid2 } from "@mui/material";
import { useSetState } from "Utils/Helpers/Hooks";
import Inputer from "Utils/Helpers/Inputer";
import MButton from "Utils/Helpers/MButton";
import { useDispatch } from "react-redux";
import { post_site_data } from "http/components/SiteData";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { enqueueSnackbar } from "notistack";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { setTamimaData } from "../../../../../Redux/slices/mngrSlice";

export default function AddTamimaData() {
  const dispatch = useDispatch();
  const [controls, setControls] = useSetState({
    title: {
      label: "Title",
      type: "text",
      multiLine: false,
      placeholder: "Enter title",
      value: "",
      validation: false,
    },
    text: {
      label: "Text",
      type: "text",
      multiLine: true,
      placeholder: "Enter text",
      value: "",
      validation: false,
    },
  });

  useEffect(() => {
    onClear();
  }, []);

  const onClear = () => {
    setControls({ title: { value: "", validation: false } });
    setControls({ text: { value: "", validation: false } });
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value, validation } });
  };

  const onSubmit = async () => {
    const { title, text } = controls;
    if (title.validation) {
      dispatch(HandleLoading(true));
      const response = await post_site_data({
        title: title.value,
        body: text.value,
        section: "tamima",
      });
      if (CheckApiStatus(response)) {
        onClear();
        dispatch(setTamimaData(true));
        enqueueSnackbar("Insert Success", { variant: "success" });
      }
      dispatch(HandleLoading(false));
    } else {
      enqueueSnackbar("Enter data correctly", { variant: "error" });
    }
  };

  return (
    <Grid2 container spacing={2}>
      {Object.keys(controls).map((key, index) => {
        return (
          <Grid2 size={{ xs: 12 }} key={key + index}>
            {controls[key].type === "text" && (
              <Inputer
                id={key}
                setValue={setValue.bind(this)}
                value={controls[key].value}
                label={controls[key].label}
                placeholder={controls[key].placeholder}
                type={controls[key].type}
                multiLine={controls[key].multiLine}
              />
            )}
          </Grid2>
        );
      })}
      <Grid2 size={{ xs: 12 }}>
        <MButton label={"Save"} onClick={onSubmit} />
      </Grid2>
    </Grid2>
  );
}
